import { TODO_INIT_LOADING, TODO_INIT_SUCCESS, TODO_INIT_FAIL, TODO_COMPLETED_LOADMORE_LOADING, TODO_COMPLETED_LOADMORE_SUCCESS, TODO_COMPLETED_LOADMORE_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'
import http from '@/utils/ajax'

export const actions = {
  async initToDo({ commit, state }) {
    commit(TODO_INIT_LOADING)
    const apiUrl = state.permitWidgets.toDoList
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(TODO_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(TODO_INIT_FAIL)
      }
    } else {
      commit(TODO_INIT_FAIL)
    }
  },
  async loadMoreCompletedToDo({ commit, state }) {
    if (!state.completedToDoList.loadingNewCompletedToDo && state.completedToDoList.hasNext) {
      commit(TODO_COMPLETED_LOADMORE_LOADING)

      const apiUrl = state.completedToDoList.menu.queryCompletedToDo
      if (apiUrl) {
        try {
          const result = await http.get(apiUrl)
          const menu = extractMenu(result.data._links)
          let commitResult = result.data
          Object.assign(commitResult, {
            menu: menu
          })
          commit(TODO_COMPLETED_LOADMORE_SUCCESS, commitResult)
        } catch (error) {
          console.log(error)
          commit(TODO_COMPLETED_LOADMORE_FAIL)
        }
      } else {
        commit(TODO_COMPLETED_LOADMORE_FAIL)
      }
    }
  }
}
